import React, { lazy } from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  const scrollToProductOptions = () => {
    // Check if product options section exists
    const productOptionsSection = document.getElementById('product-options');
    if (productOptionsSection) {
      // If it exists, scroll to it
      productOptionsSection.scrollIntoView({
        behavior: 'smooth'
      });
    } else {
      // If it doesn't exist yet (hidden due to timer), show a message
      alert('Our special offers will be available soon! Please watch the video to learn more.');
      // Optionally, scroll to top of page or another section
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full py-12 bg-gray-50 px-4" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="mb-16" data-id="element-36">
          <div className="text-center mb-6" data-id="element-37">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-38">
              Eliminate "Dormant Follicles" & Restore Your Vibrant Hair
            </h2>
            <p className="mt-4 max-w-4xl mx-auto text-lg" data-id="element-39">
              Hair Growth Oil 3.0 is a powerful natural formula that harnesses
              10 potent botanicals to eliminate hair loss by{' '}
              <span className="font-bold" data-id="element-40">
                targeting the root cause of baldness: environmental toxins and
                cellular damage patterns.
              </span>
            </p>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 my-8" data-id="element-41">
            <div className="md:w-1/2" data-id="element-42">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/85ksNmumY1TRxrdNr1EZ9q/ChatGPT_Image_30_%CE%99%CE%BF%CF%85%CE%BB_2025%2C_03_13_07_%CE%BC.%CE%BC..webp" alt="Hair Transformation Results Before and After" className="rounded-lg shadow-lg w-full" loading="lazy" width="600" height="400" decoding="async" data-id="element-43" />
            </div>
          </div>
          <div className="mt-12" data-id="element-44">
            <h3 className="text-2xl font-bold text-center mb-8" data-id="element-45">
              What People Like YOU Think:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-46">
              <div className="flex items-center gap-4" data-id="element-47">
                <div className="relative w-20 h-20 flex-shrink-0" data-id="element-48">
                  <div className="w-20 h-20 rounded-full border-4 border-green-500" data-id="element-49"></div>
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center" data-id="element-50">
                    <span className="text-xl font-bold" data-id="element-51">96%</span>
                  </div>
                </div>
                <p className="text-lg" data-id="element-52">
                  Noticed New Hair Growth Within 30 Days
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-53">
                <div className="relative w-20 h-20 flex-shrink-0" data-id="element-54">
                  <div className="w-20 h-20 rounded-full border-4 border-green-500" data-id="element-55"></div>
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center" data-id="element-56">
                    <span className="text-xl font-bold" data-id="element-57">92%</span>
                  </div>
                </div>
                <p className="text-lg" data-id="element-58">
                  Reported Thicker, Fuller Hair Within 60 Days
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-59">
                <div className="relative w-20 h-20 flex-shrink-0" data-id="element-60">
                  <div className="w-20 h-20 rounded-full border-4 border-green-500" data-id="element-61"></div>
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center" data-id="element-62">
                    <span className="text-xl font-bold" data-id="element-63">89%</span>
                  </div>
                </div>
                <p className="text-lg" data-id="element-64">
                  Noticed Reduced Hair Shedding After 2 Weeks
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-65">
                <div className="relative w-20 h-20 flex-shrink-0" data-id="element-66">
                  <div className="w-20 h-20 rounded-full border-4 border-green-500" data-id="element-67"></div>
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center" data-id="element-68">
                    <span className="text-xl font-bold" data-id="element-69">94%</span>
                  </div>
                </div>
                <p className="text-lg" data-id="element-70">
                  Reported Healthier Scalp Condition Within 3 Weeks
                </p>
              </div>
            </div>
            <p className="text-center text-sm text-gray-600 mt-4" data-id="element-71">
              * Results according to a consumer test with 325 participants.
            </p>
            <div className="text-center mt-8" data-id="element-72">
              <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full" onClick={scrollToProductOptions} data-id="element-73">
                I WANT THESE RESULTS TOO!
              </button>
            </div>
          </div>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-74">
          Why People Love Hair Growth Oil 3.0
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-75">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-76">
            <h3 className="text-xl font-bold mb-4" data-id="element-77">
              Scientifically Proven Formula
            </h3>
            <ul className="space-y-3" data-id="element-78">
              <li className="flex items-start" data-id="element-79">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-80" />
                <span data-id="element-81">Deactivates 'Toxic Cells' in just 30 days</span>
              </li>
              <li className="flex items-start" data-id="element-82">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-83" />
                <span data-id="element-84">Stops environmental hair loss at the root cause</span>
              </li>
              <li className="flex items-start" data-id="element-85">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-86" />
                <span data-id="element-87">Stimulates dormant follicles for new growth</span>
              </li>
              <li className="flex items-start" data-id="element-88">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-89" />
                <span data-id="element-90">All-natural Indonesian formula with no side effects</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-91">
            <h3 className="text-xl font-bold mb-4" data-id="element-92">What Makes Us Different</h3>
            <ul className="space-y-3" data-id="element-93">
              <li className="flex items-start" data-id="element-94">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-95" />
                <span data-id="element-96">
                  Rare botanicals sourced from remote Indonesian regions
                </span>
              </li>
              <li className="flex items-start" data-id="element-97">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-98" />
                <span data-id="element-99">
                  Developed by Stanford University hair loss specialist
                </span>
              </li>
              <li className="flex items-start" data-id="element-100">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-101" />
                <span data-id="element-102">Addresses cellular damage AND environmental causes</span>
              </li>
              <li className="flex items-start" data-id="element-103">
                <CheckCircleIcon className="text-green-500 mr-2 flex-shrink-0 mt-1" size={20} data-id="element-104" />
                <span data-id="element-105">Over 100,000 satisfied customers worldwide</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center" data-id="element-106">
          <h3 className="text-xl font-bold mb-4" data-id="element-107">
            Start Your Hair Revival Journey Today
          </h3>
          <p className="mb-6 max-w-2xl mx-auto" data-id="element-108">
            Join thousands of men who have successfully reversed their hair loss
            with our revolutionary formula.
          </p>
          <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full" onClick={scrollToProductOptions} data-id="element-109">
            CLAIM MY HAIR GROWTH OIL 3.0 NOW
          </button>
        </div>
      </div>
    </section>;
}